"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Entitlements = void 0;
const ROSTER_REGISTRAR = "roster.registrar";
const LIVE_GAME_EVENTS = "liveGameEvents";
const PRE_GAME_EVENTS = "pregameService";
const LOCATIONS = "locations";
const STATS = "stats";
const Entitlements = {
    ROSTER_REGISTRAR,
    LIVE_GAME_EVENTS,
    PRE_GAME_EVENTS,
    LOCATIONS,
    STATS,
};
exports.Entitlements = Entitlements;
